module.exports = __webpack_public_path__ + "img/ssSmalSearch.07a14f4e.svg";